import { patchProviderDetails, patchUserProfile, UserPrefix } from '@uplift/api';
import { useL10n } from '@uplift/hooks';
import { useUpdateSettingsHandlers } from '@uplift/ui-v2';
import { VALIDATION_PREFERRED_NAME } from '@uplift/validations';
import * as Yup from 'yup';
import { SettingsData } from '../../../hooks/use-settings-data.hook';

export type NameFormType = {
  prefix: string | null;
  legalName: string;
  preferredName?: string;
  mentalHealthRoleSuffixes: string[];
};

export const useNameForm = (userId: string, data: SettingsData) => {
  const l10n = useL10n();
  const { onFormSubmitSuccess, onFormSubmitError } = useUpdateSettingsHandlers(userId, l10n.providerSettings.name);

  const nameFormik = () => {
    const initialValues: NameFormType = {
      prefix: data?.profile?.prefix ?? null,
      legalName: `${data?.user?.firstName} ${data?.user?.lastName}`,
      preferredName: data?.profile?.preferredName,
      mentalHealthRoleSuffixes: data?.mentalHealthRoles
        .filter(r => r.suffix != null)
        .map(r => r.id) ?? []
    };

    const validationSchema = Yup.object({
      prefix: Yup.string().oneOf([ UserPrefix.dr, null ]).nullable(),
      legalName: Yup.string(),
      preferredName: VALIDATION_PREFERRED_NAME,
      mentalHealthRoleSuffixes: Yup.array(Yup.string())
    });

    const onSubmit = async (values: NameFormType) => {
      try {
        await patchUserProfile(userId, {
          preferredName: values.preferredName,
          prefix: values.prefix === UserPrefix.dr ? UserPrefix.dr : null
        });
        await patchProviderDetails(userId, {
          displayCredentials: values.mentalHealthRoleSuffixes
        });

        await onFormSubmitSuccess(true);
      } catch (error) {
        onFormSubmitError();
      }
    };

    return { initialValues, validationSchema, onSubmit };
  };

  return { nameFormik };
};
